import React from "react";
import { Globe, Check } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "./ui/dropdown-menu";
import { useLang } from "../i18n/LangContext";

const LanguageSwitcher = ({ dark = true }) => {
  const { lang, setLang, langs } = useLang();
  const current = langs.find(l => l.code === lang) || langs[0];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger className={`inline-flex items-center gap-2 h-10 px-3 rounded-full text-sm font-medium transition ${dark ? "bg-white/8 hover:bg-white/14 text-white border border-white/15" : "bg-amber-50 hover:bg-amber-100 text-slate-800 border border-amber-200"}`}>
        <Globe className="w-4 h-4" />
        <span className="text-base leading-none">{current.flag}</span>
        <span className="hidden sm:inline uppercase text-xs tracking-wider">{current.code}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[180px]">
        {langs.map(l => (
          <DropdownMenuItem key={l.code} onClick={() => setLang(l.code)} className="cursor-pointer flex items-center justify-between">
            <span className="flex items-center gap-2"><span className="text-base">{l.flag}</span> {l.label}</span>
            {lang === l.code && <Check className="w-4 h-4 text-amber-600" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSwitcher;
